import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const LanguageFilterIcon = (props: any) => {
  const theme = useContext(ThemeContext);
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.32918 13.6646C5.14394 14.0351 5.29411 14.4856 5.66459 14.6708C6.03507 14.8561 6.48558 14.7059 6.67082 14.3354L5.32918 13.6646ZM10 6L10.6708 5.66459C10.5438 5.4105 10.2841 5.25 10 5.25C9.71592 5.25 9.45622 5.4105 9.32918 5.66459L10 6ZM13.3292 14.3354C13.5144 14.7059 13.9649 14.8561 14.3354 14.6708C14.7059 14.4856 14.8561 14.0351 14.6708 13.6646L13.3292 14.3354ZM7.14286 11.7143L6.47204 11.3789L7.14286 11.7143ZM12.8571 11.7143L13.528 11.3789L12.8571 11.7143ZM6.67082 14.3354L7.81368 12.0497L6.47204 11.3789L5.32918 13.6646L6.67082 14.3354ZM7.81368 12.0497L10.6708 6.33541L9.32918 5.66459L6.47204 11.3789L7.81368 12.0497ZM9.32918 6.33541L12.1863 12.0497L13.528 11.3789L10.6708 5.66459L9.32918 6.33541ZM12.1863 12.0497L13.3292 14.3354L14.6708 13.6646L13.528 11.3789L12.1863 12.0497ZM7.14286 12.4643H12.8571V10.9643H7.14286V12.4643Z"
        fill={theme.colors.neutrals.c400}
        stroke="none"
      />
      <rect x="2.75" y="2.75" width="14.5" height="14.5" rx="2.25" strokeWidth="1.5" />
    </svg>
  );
};

export default LanguageFilterIcon;
